<div class="h-full w-full gap-6">
  <app-page-header>
    <div class="flex flex-row justify-start items-center gap-2 h-10">
      <span>Organisation Erstellen</span>
    </div>
  </app-page-header>
<div class="h-full w-full overflow-y-scroll p-6">
  <bic-accordion #accordion [disableManualToggle]="true" [gapBetweenElements]="0" [openedIndex]=0>
    @if (organisationForm) {
<bic-accordion-element (opened)="expandedElement = 0" (closed)="expandedElement = null"
                           #orgaPanel>
      <bic-accordion-header>
        <div>
          <span>1. Neue Organisation</span>
        </div>
      </bic-accordion-header>
      <bic-accordion-body>
        <ng-container *ngTemplateOutlet="generalData"></ng-container>
      </bic-accordion-body>
    </bic-accordion-element>
}

    <bic-accordion-element (opened)="expandedElement = 1" (closed)="expandedElement = null" #addressPanel>
      <bic-accordion-header>
        <div>
          <span>2. Adresse</span>
        </div>
      </bic-accordion-header>
      <bic-accordion-body>
        @if (organisationForm) {

          <ng-container *ngTemplateOutlet="placeData"></ng-container>
        
}
      </bic-accordion-body>
    </bic-accordion-element>
  </bic-accordion>

</div>

<ng-template #generalData>
  <form [formGroup]="organisationForm" class="column-form flex flex-col justify-between">
    <div class="flex flex-row items-start justify-between">
      <div class="flex flex-col w-full gap-5">
        <div class="flex flex-row gap-6">
          <div class="flex flex-col w-full">
            <bic-input class="w-full" [label]="'Name der Organisation *'" [formControlName]="'name'"
                       [placeholder]="'Name der Organisation eingeben'" [maxLength]="64"
                       [required]="true"
                       [errorCondition]="!!fieldError('name')"></bic-input>
            @if (fieldError('name'); as error) {
              <span class="text-xs text-red-500 pt-1">{{ error }}</span>
            }
          </div>

          <bic-select class="w-full" [label]="'Rechtsform *'" [formControlName]="'legalForm'" [placeholder]="'Auswählen'"
                      [required]="true">
            @for (i of legalForm | keyvalue; track i) {
              <bic-dropdown-element [value]="i.value">
                {{ i.value | legalForms }}
              </bic-dropdown-element>
            }
          </bic-select>
        </div>
        <div class="flex flex-row gap-6">
          <div class="flex flex-col w-full">
            <bic-input [formControlName]="'organisationMail'" [label]="'Geschäftliche E-Mail *'"
                       [placeholder]="'Geschäftliche E-Mail eingeben'"
                       [errorCondition]="!!fieldError('organisationMail')"
                       class="w-full"></bic-input>
            @if (fieldError('organisationMail'); as error) {
              <span class="text-xs text-red-500 pt-1">{{ error }}</span>
            }
          </div>
          <bic-input [formControlName]="'vatNumber'" [label]="'Umsatzsteueridentifikationsnummer'"
                     [placeholder]="'Umsatzsteueridentifikationsnummer eingeben'"
                     class="w-full"></bic-input>
        </div>
      </div>
    </div>
  </form>
  <div class="flex flex-row justify-end gap-4 pt-5">
    <bic-button (onClick)="cancel()" buttonType="white">Abbrechen</bic-button>
    <div [tooltip]="nextDisabledHint" [tooltipDirection]="'top'" class="inline-block">
      <bic-button (onClick)="accordion.open(1)" [disabled]="nextDisabled">Weiter
        <fa-icon [icon]="faChevronRight" iconRight></fa-icon>
      </bic-button>
    </div>
  </div>
</ng-template>

<ng-template #placeData>
  <app-address-input [formGroup]="organisationForm"></app-address-input>
  <div class="flex flex-row justify-end gap-4 pt-5">
    <bic-button (onClick)="cancel()" buttonType="white">Abbrechen</bic-button>
    <bic-button (onClick)="accordion.open(0)" buttonType="white">
      <fa-icon [icon]="faChevronLeft" iconLeft></fa-icon>
      Zurück
    </bic-button>
    <bic-button (onClick)="save()" [disabled]="createOrgDisabled">Erstellen
      <fa-icon [icon]="faChevronRight" iconRight></fa-icon>
    </bic-button>
  </div>
</ng-template>

<ng-template #memberData>
  @if (organisation && permissionService.hasOrganisationPrivilege('ORGANISATION_USER_MANAGEMENT', organisation.id!)) {
    <div class="flex flex-col justify-start gap-8">
      @if (organisation.id != -1 && permissionService.hasOrganisationPrivilege('ORGANISATION_USER_MANAGEMENT', organisation.id!)) {
        <app-users-list
          [addDisabled]="!permissionService.hasOrganisationPrivilege('ORGANISATION_USER_MANAGEMENT', organisation.id!)"
          [changeEventTriggered]="organisationChangedEvent.asObservable()"
          [deleteDisabled]="!permissionService.hasOrganisationPrivilege('ORGANISATION_USER_MANAGEMENT', organisation.id!)"
          [isProject]="false"
          [organisation]="organisation!"
          [permissionsDisabled]="!permissionService.hasOrganisationPrivilege('ORGANISATION_USER_MANAGEMENT', organisation.id!)"
        ></app-users-list>
      }
    </div>
  }
</ng-template>
